import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

import { API } from "../tic"

export default new Vuex.Store({
  state: {
    version: "1.10",
    authenticated: false,

    forms: {},

    session: {},

    user: {
      login: "",
      name: "",
      email: "",
    },
  },

  mutations: {
    setUser(state, { data, isError, authenticated, session }) {
      console.log("--> setUser:  auth", authenticated)
      state.authenticated = authenticated
      state.session = JSON.parse(JSON.stringify(data.session))
      state.user = JSON.parse(JSON.stringify(data.user))
    },
  },

  getters: {
    forms(state) {
      return state.forms
    },

    displayname(state) {
      // return best displayname (in order of appearance)
      return (
        [state.user.name, state.user.login, state.user.email].filter(
          (n) => n
        )[0] || "Anonymous"
      )
    },

    isAdmin(state) {
      if (state.authenticated) {
        if (state.user && state.user.is_admin) {
          return true
        }
      }
      return false
    },
  },

  actions: {
    init(ctx) {
      console.log("⇒ **** Historiana Admin INIT **", ctx)

      // ctx.state.forms.linktypes = [{ uuid: 1, name: "linktype" }]
      // API.get("/data/linktypes").then((r) => {
      //   console.log("GET LINKTYPES ", r.data.data)
      //   ctx.state.forms.linktypes = r.data.data
      // })

      // API.get("/data/licenses").then((r) => {
      //   console.log("GET LINKTYPES ", r.data.data)
      //   ctx.state.forms.licenses = r.data.data
      // })

      // checkbox shit

      API.get("/admin/form-meta").then((r) => {
        ctx.state.forms = r.data.data
      })
    },
  },
  modules: {},
})
